import React, { Component } from "react";
import { Modal, Input, Button, Icon } from "semantic-ui-react";
import mime from "mime-types";

class FileModal extends Component {
    state = {
        file: null
    };

    addFile = e => {
        const file = e.target.files[0];
        if (file) {
            console.log(file);
            this.setState({ file });
        }
    };

    sendFile = () => {
        const { file } = this.state;
        const { uploadFile, closeModal } = this.props;

        if (file) {
            const metadata = {
                contentType: mime.lookup(file.name),
                extension: mime.extension(mime.lookup(file.name))
            };
            uploadFile(file, metadata);
            closeModal();
            this.setState({ file: null });
        }
    };

    render() {
        const { modal, closeModal } = this.props;

        return (
            <Modal basic size="small" open={modal} onClose={closeModal}>
                <Modal.Header>Upload a File</Modal.Header>
                <Modal.Content>
                    <Input
                        fluid
                        name="file"
                        type="file"
                        onChange={this.addFile}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button inverted color="green" onClick={this.sendFile}>
                        <Icon name="reply" /> Send
                    </Button>
                    <Button inverted color="red" onClick={closeModal}>
                        <Icon name="remove" /> Cancel
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default FileModal;
